/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_Ac_TextInputs */

const en_dr_proof_ac_text = /** @type {(inputs: Dr_Proof_Ac_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`validates: H-1 — deposit charged automatically via VA before the slot is held`)
};

const id_dr_proof_ac_text = /** @type {(inputs: Dr_Proof_Ac_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`validates: H-1 — DP terpotong otomatis via VA sebelum slot ditahan`)
};

/**
* | output |
* | --- |
* | "validates: H-1 — deposit charged automatically via VA before the slot is held" |
*
* @param {Dr_Proof_Ac_TextInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_ac_text = /** @type {((inputs?: Dr_Proof_Ac_TextInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_Ac_TextInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_ac_text(inputs)
	return en_dr_proof_ac_text(inputs)
});